import { useBrand } from '@/branding/useBrand'
import LoginDefault from './login/LoginDefault'
import LoginEditorial from './login/LoginEditorial'

export default function LoginPage() {
  const brand = useBrand()
  return brand.loginLayout === 'editorial' ? <LoginEditorial /> : <LoginDefault />
}
